<template>
  <v-container class="pa-1">
    <screen
      v-if="step === steps.WAITER"
      :title="$t('field.text_num_employe')"
      :info="inputVal"
      use-amount
    />
    <screen
      v-else-if="step === steps.FREE"
      :title="$t('title.amount_tips')"
      :info="$amount(inputVal)"
      use-amount
    />
    <amount v-else />

    <template v-if="step === steps.CHOICE">
      <h4 class="mt-5 py-5 text-center">
        {{ $t('title.give_tips') }}
      </h4>

      <div class="d-flex">
        <img
          :src="LogoImages.tips"
          alt="tip-logo"
          class="mx-auto mb-5"
          style="max-width: 30vh;max-height: 30vh"
        >
      </div>

      <div class="px-5">
        <v-btn
          color="success"
          block
          x-large
          @click="step = steps.PRICE"
        >
          Oui
        </v-btn>
      </div>

      <div class="pull-bottom bloc mb-5 px-5">
        <v-btn
          color="error"
          block
          outlined
          @click="refuseTip"
        >
          Non
        </v-btn>
      </div>
    </template>

    <template v-else-if="step === steps.PRICE">
      <h4 class="my-5 py-5 text-center">
        {{ $t('title.give_tips_amount') }}
      </h4>

      <payment-btn
        v-for="a in amounts"
        :key="a"
        :name="`amount-${a}`"
        :title="$amount(a)"
        class="half-bloc"
        color="#5b5b5b"
        @click="valid(a)"
      />
      <payment-btn
        v-if="useFreeAmount"
        title="Montant libre"
        name="free-amount"
        class="mt-5"
        color="#5b5b5b"
        @click="inputVal = 0; step = steps.FREE"
      />
    </template>

    <keyboard
      v-else
      v-model="inputVal"
      @del="del"
      @valid="valid()"
      @cancel="step === steps.WAITER ? $router.replace('/home') : step = steps.PRICE"
    />
  </v-container>
</template>

<script>
import { $amount, needToAskDonation } from '@/modules/Utils'
import { LogoImages } from '@/modules/Images'
import Amount from '@/components/Amount.vue'

export default {
  name: 'TipsView',

  components: {
    Amount
  },

  props: {
    goToCashless: { type: Boolean, default: false }
  },

  data () {
    return {
      LogoImages,
      steps: {
        WAITER: 0,
        CHOICE: 1,
        PRICE: 2,
        FREE: 3
      },
      step: 0,
      //
      inputVal: 0
    }
  },

  computed: {
    tipAmount () { return this.$store.state.amount },
    amounts () {
      const amounts = []
      this.$store.getters.tipCampaign.Rules.forEach(rule => {
        if (rule.TypeValeur === 'F' && rule.Valeur) amounts.push(rule.Valeur)
      })
      return amounts
    },
    useFreeAmount () {
      return this.$store.getters.tipCampaign.Rules.findIndex(rule => rule.TypeValeur === 'N') !== -1
    }
  },

  beforeMount () {
    this.$emit('title', this.$i18n.t('title.tips'))
    this.$store.commit('tipAmount', 0)
  },

  methods: {
    $amount,
    // Validation du pourboire
    valid (amount = this.inputVal) {
      if (this.step === this.steps.WAITER) {
        this.$store.commit('waiterNumber', this.inputVal)
        this.step = this.steps.CHOICE
      } else {
        this.$store.commit('tipAmount', amount)
        this.toPayment()
      }
    },
    del () {
      if (this.step === this.steps.WAITER) {
        this.$router.replace('/home')
      } else {
        this.step = this.steps.PRICE
      }
    },
    toPayment () {
      // Verifie les parametrage pour la campagne de don
      if (needToAskDonation()) {
        this.$router.replace({ name: 'donation', params: { goToCashless: this.goToCashless } })
      } else {
        // Va à la route Home pour effectuer le payement si Don est désactivé
        this.$router.replace({ name: 'banking-payment', params: { goToCashless: this.goToCashless, directPayment: true } })
      }
    },
  }
}
</script>
